import * as R from 'ramda';

import { setInDefaultValue, setInDefaultNotEmptyValue } from 'decorators';
import { getIn, setIn } from 'utils';

function setDefultPropertyValues(input = {}) {
  return R.pipe(
    setInDefaultValue('leased_long_term', 'occupancy'),
    setInDefaultValue(0, 'completedRepairsValue'),
    setInDefaultValue('0.00', 'reTaxes'),
    setInDefaultValue('0.00', 'associationFee'),
    setInDefaultValue('0.00', 'insurance'),
    setInDefaultValue('0.00', 'miscExpenses'),
    setInDefaultValue('annual', 'reTaxesPeriod'),
    setInDefaultValue('monthly', 'associationFeePeriod'),
    setInDefaultValue('annual', 'insurancePeriod'),
    setInDefaultValue('monthly', 'miscExpensesPeriod'),
  )(input);
}

function setDefaultProperties(input = {}) {
  const properties = R.pipe(
    setInDefaultNotEmptyValue([{}], 'application.properties'),
    getIn('application.properties'),
    R.map(setDefultPropertyValues),
  )(input);

  return setIn(properties, 'application.properties', input);
}

function setDefaultInitialValues(input = {}) {
  return R.pipe(setDefaultProperties)(input);
}

export { setDefultPropertyValues, setDefaultInitialValues };
